<template>

  <div class="row">

  </div>

</template>

<script>
  export default {
    name: 'login',
    data: () => ({
      users: [],
      authData: {
        id: '',
        access_token: ''
      }
    }),
    computed: {
    },
    methods: {
      validateAuth(){
        this.$http.secured.post('validate-auth', this.authData)
          .then(response => {
            this.$store.commit('setCurrentUser', { currentUser: response.data })

            if(response.data.user_details.role == this.$getConstRole('ROLE_SUB_ADMIN')){
              window.location.href = '/admin/channels'
            }else{
              window.location.href = '/dashboard'
            }

          })
          .catch(error => {
            this.$store.commit('unsetCurrentUser')
            window.location.href = '/signin-error'
          })
      }
    },
    mounted() {
      if(this.$route.query.id){
        this.authData.id = this.$route.query.id
        this.authData.access_token = this.$route.query.access_token
        this.validateAuth()
        return false
      } else {
        this.$store.commit('unsetCurrentUser')
        window.location.href = '/signout'
      }
    },
    components: {

    }
  }
</script>
